"use client";

import {
  type IconLoadTier,
  registerIconLoadRequest,
  updateIconLoadTier,
} from "@/lib/icon-load-coordinator";
import { useLayoutEffect, useState } from "react";

export interface UseCoordinatedIconLoadOptions {
  requestId: string;
  imageUrl: string;
  tier: IconLoadTier;
  priority: boolean;
  nearViewport: boolean;
}

export function useCoordinatedIconLoad({
  requestId,
  imageUrl,
  tier,
  priority,
  nearViewport,
}: UseCoordinatedIconLoadOptions): boolean {
  const [canLoad, setCanLoad] = useState(priority);

  useLayoutEffect(() => {
    if (!nearViewport && !priority) {
      setCanLoad(false);
      return;
    }

    const unregister = registerIconLoadRequest({
      id: requestId,
      imageUrl,
      tier: priority ? "visible" : tier,
      priority,
      onGrant: () => setCanLoad(true),
    });

    return unregister;
  }, [imageUrl, nearViewport, priority, requestId]);

  useLayoutEffect(() => {
    if (!nearViewport && !priority) return;
    updateIconLoadTier(requestId, priority ? "visible" : tier, priority);
  }, [nearViewport, priority, requestId, tier]);

  return canLoad;
}
